module.exports = __webpack_public_path__ + "wave-3.svg?6e9bc8666e49d1d254dca503b199e299";